import React, { useEffect } from "react";
import { BrowserView, MobileView } from "react-device-detect";
import { useLocation, useNavigate } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

const NavLinks = ({ onNavigate }) => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        // console.log(location);
        if (location.hash) {
            let elem = document.getElementById(location.hash.slice(1));
            if (elem) {
                elem.scrollIntoView({ behavior: "smooth" });
            }
        } else {
            window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        }
    }, [location]);

    function handleNavigate(to, targetId) {
        // console.log("handleNavigate", to, "#" + targetId);
        navigate(`${to}#${targetId}`);
        onNavigate();
    }
    return (
        <div>
            <BrowserView>
                <HashLink className="px-4 font-extrabold text-gray-500 fg-primary-hover" smooth to="/#">
                    Home
                </HashLink>
                <HashLink className="px-4 font-extrabold text-gray-500 fg-primary-hover" smooth to="/#about">
                    About
                </HashLink>
                <HashLink className="px-4 font-extrabold text-gray-500 fg-primary-hover" smooth to="/#services">
                    Services
                </HashLink>
                <HashLink className="px-4 font-extrabold text-gray-500 fg-primary-hover" to="/contact#contact">
                    Contact Us
                </HashLink>
                <HashLink
                    className="text-white bg-primary bg-primary-hover-80 inline-flex items-center justify-center w-auto px-6 py-3 shadow-xl rounded-xl ml-5"
                    smooth
                    to="/request-quote"
                >
                    Request a quote
                </HashLink>
            </BrowserView>

            <MobileView className="flex flex-col align-items-start justify-content-start">
                <div
                    className="px-4 font-extrabold text-gray-500 fg-primary-hover py-3"
                    onClick={() => handleNavigate("/", "")}
                >
                    Home
                </div>
                <div
                    className="px-4 font-extrabold text-gray-500 fg-primary-hover py-3"
                    onClick={() => handleNavigate("/", "about")}
                >
                    About
                </div>
                <div
                    className="px-4 font-extrabold text-gray-500 fg-primary-hover py-3"
                    onClick={() => handleNavigate("/", "services")}
                >
                    Services
                </div>
                <div
                    className="px-4 font-extrabold text-gray-500 fg-primary-hover py-3"
                    onClick={() => handleNavigate("/contact", "contact")}
                >
                    Contact Us
                </div>
                <div
                    className="text-white bg-primary bg-primary-hover-80 inline-flex items-center justify-center w-auto px-6 py-3 shadow-xl rounded-xl mt-5"
                    onClick={() => handleNavigate("/request-quote", "quote")}
                >
                    Request a quote
                </div>
            </MobileView>
        </div>
    );
};

export default NavLinks;
